export default {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: state => {
        const route = '/audience_admin/accounts/' + state.accountId + '/detail/json'
        const params = {}
        return { route, params }
    }
}
